import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { updateTaxCertApplicationData } from '../../../store/slices/taxCertificate/taxCertificateSlice';
import { useAppDispatch } from '../../../store/store';
import { selectTaxCertApplicationData } from '../../../store/slices/taxCertificate/taxCertificateSelectors';
import { FLOWS_ENUM } from '../../../common/enums';
import { ApplicationData } from '../../../types/flow';
import { ContactsPage } from '../../../components/pages/ContactsPage';

const TaxCertContacts = () => {
  const dispatch = useAppDispatch();
  const data = (useSelector(selectTaxCertApplicationData) ??
    {}) as ApplicationData;

  const updateApplicationData = useCallback(
    (updated: ApplicationData) => {
      dispatch(updateTaxCertApplicationData(updated));
    },
    [dispatch]
  );

  return (
    <ContactsPage
      data={data}
      flow={FLOWS_ENUM.TAX_CERTIFICATE}
      updateApplicationData={updateApplicationData}
    />
  );
};

export default TaxCertContacts;
